import { Testimonial } from '../types';

export const testimonials: Testimonial[] = [
  {
    id: '1',
    client: 'Fran Cheska',
    title: 'Business Owner',
    projectType: 'Custom Web Development',
    quote: 'SkyCode helped bring our ideas to life. The development process was smooth, and the end result exceeded our expectations.',
    logo: '/clients/facebook.png'
  },
  {
    id: '2',
    client: 'Anya Montemayor',
    title: 'Startup Founder',
    projectType: 'E-Commerce Platform',
    quote: 'We\'re extremely satisfied with the quality of work from SkyCode. Clean code, great UI design, and solid performance.',
    logo: '/clients/facebook.png'
  },
  {
    id: '3',
    client: 'Nicole Arada',
    title: 'Product Manager',
    projectType: 'Mobile App Development',
    quote: 'Incredible experience working with SkyCode! Their developers are knowledgeable and easy to communicate with.',
    logo: '/clients/facebook.png'
  },
  {
    id: '4',
    client: 'Rich Trentase',
    title: 'Business Owner',
    projectType: 'Custom System Development',
    quote: 'SkyCode has been a reliable tech partner for our business. Their team is skilled, professional, and always delivers on time.',
    logo: '/clients/facebook.png'
  },
  {
    id: '5',
    client: 'Trinidad Mabuhay',
    title: 'CEO',
    projectType: 'Web Application',
    quote: 'SkyCode isn\'t just a dev team — they\'re collaborators. We felt fully supported throughout the entire process.',
    logo: '/clients/facebook.png'
  }
];
